module.exports = __webpack_public_path__ + "static/media/Lima_Capital_Cookie_Policy.ef465c63.pdf";